module.exports = __webpack_public_path__ + "img/zh3.7e21a31c.png";